export var HeaderTabEnum;
(function (HeaderTabEnum) {
    HeaderTabEnum["Overview"] = "overview";
    HeaderTabEnum["Listings"] = "listings";
    HeaderTabEnum["Domains"] = "domains";
    HeaderTabEnum["Sellers"] = "sellers";
})(HeaderTabEnum || (HeaderTabEnum = {}));
